<template>
    <div>
   
       <b-table striped hover :items="data" ref="document" id="report"></b-table>
    </div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Logo from "@/assets/img/sanatLogo.png"
    export default {
        name: 'PdfReport',
        props:{
            data: Object
        },
        methods:{

            exportToPDF () {
                var docDefinition = {
                    pageMargins: [ 15, 10, 20, 20 ],
                    pageSize: 'A3',
                    content: [
                        {
                            columns: [
                                {
                                    image: Logo,
                                },
                                {
                                width: '50%',
                                text: [
                                    { text: 'Sanat Teknoloji\n\n', bold: true },
                                    { text: 'Adres: ', bold: true },
                                    { text: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9/A Ümraniye / İstanbul \n' },
                                    { text: 'Telefon: ', bold: true },
                                    { text: '0850 259 00 99\t' },
                                    { text: 'E-posta: ', bold: true },
                                    { text: 'bilgi@sanatteknoloji.com.tr\n' },
                                    { text: 'İnternet Adresi: ', bold: true },
                                    { text: 'www.sanatteknoloji.com.tr' },
                                ]
                                },
                            ],
                            margin: [0, 0, 0, 15],
                            linearGradient: ['red', 'green', 'blue', 'red'],
                            
                        },
                        {
                            table : {
                                headerRows : 1,
                                widths: ['100%'],
                                body : [ [''], [''] ]
                            },
                            layout : 'headerLineOnly'
                        },              
                        {
                            table: {
                                headerRows: 1,
                                margin:[0],
                                widths: [90, 90, 130, '*', '*', '*', '*', '*', '*', '90%'],
                                body: [
                                    [
                                        { text: 'Ad', bold: true, alignment: 'center' },
                                        { text: 'Vergi/TC Kimlik No', bold: true, alignment: 'center' },
                                        { text: 'Adres', bold: true, alignment: 'center' },
                                        { text: 'İl', bold: true, alignment: 'center'},
                                        { text: 'İlçe', bold: true, alignment: 'center' },
                                        { text: 'Kamera', bold: true, alignment: 'center' },
                                        { text: 'Alarm', bold: true, alignment: 'center' },
                                        { text: 'Sözleşme No', bold: true, alignment: 'center' },
                                        { text: 'Başlangıç Tarihi', bold: true, alignment: 'center' },

                                    ],
                                ]
                            },
                            layout: 'lightHorizontalLines'
                        },
                        
                ] };
                for(let i = 0; i < this.data.length; i++){
                   docDefinition.content[2].table.body.push([
                        { text: this.data[i].name, alignment: 'center' },
                        { text: this.data[i].idNo, alignment: 'center' },
                        { text: this.data[i].address, alignment: 'center' },
                        { text: this.data[i].city, alignment: 'center'},
                        { text: this.data[i].district, alignment: 'center' },
                        { text: this.data[i].camera, alignment: 'center' },
                        { text: this.data[i].alarm, alignment: 'center' },
                        { text: this.data[i].account, alignment: 'center' },
                        { text: this.data[i].date, alignment: 'center' },   
                    ])
                }
               
                pdfMake.vfs = pdfFonts.pdfMake.vfs;
                 pdfMake.createPdf(docDefinition).download('optionalName.pdf');
			}
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Reports/modals/PdfReport.vue